import * as React from "react";
import type { OccupancyFloor } from "./occupancyStatistics";
import { OccupancySummary } from "./OccupancySummary";

interface OccupancyOverviewFloorProps {
  floor: OccupancyFloor;
}

export const OccupancyOverviewFloor: React.FC<OccupancyOverviewFloorProps> = ({ floor }) => (
  <li className="occupancy-overview__row">
    <h3 className="stats-results__name occupancy-overview__name">{floor.name}</h3>
    <OccupancySummary totals={floor.totals} hideLabel />
  </li>
);
